<script>
    let { copy, scale } = $props();

    const min = $derived(scale.domain[0]);
    const max = $derived(scale.domain[scale.domain.length - 1]);

    const pct = $derived(scale.domain.map(v => ((v - min) / (max - min)) * 100));

    const gradient = $derived(
        'linear-gradient(to right, ' +
        scale.range.map((color, i) => `${color} ${pct[i]}%`).join(', ') +
        ')'
    );
</script>
<div class="legend-title">{copy.legend}</div>
<div class="legend-container">
    
    <div class="legend-bar-wrap">
        <div class="legend-bar" style="background: {gradient}"></div>
        <div class="legend-ticks">
            {#each scale.domain as tick, i}
                <div class="legend-tick" style="left: {pct[i]}%">
                    <div class="tick-mark"></div>
                    {#if tick > 0}
                        <div class="tick-label">+{+tick.toFixed(1)}</div>
                    {:else}
                        <div class="tick-label">{+tick.toFixed(1)}</div>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
</div>

<style lang="scss">
    .legend-container {
        // margin: auto;
        width: 250px;
    }

    .legend-title {
        font-weight: 700;
        font-size: 14px;
        margin-bottom: 6px;
    }

    .legend-bar-wrap {
        position: relative;
        padding-bottom: 20px;
    }

    .legend-bar {
        height: 10px;
        width: 100%;
        border-radius: 2px;
    }

    .legend-ticks {
        position: relative;
        height: 20px;
    }

    .legend-tick {
        position: absolute;
        transform: translateX(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .tick-mark {
        width: 1px;
        height: 4px;
        background: currentColor;
        opacity: 0.4;
    }

    .tick-label {
        font-size: 11px;
        font-weight: 300;
        margin-top: 2px;
        white-space: nowrap;
        
    }

    .legend-tick:first-child .tick-label{
        transform: translateX(5px);
    }
</style>
